import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { resolveImg } from "@/lib/api";

const STAT_IDS = [
  "stat-item-years",
  "stat-item-mechanics",
  "stat-item-projects",
  "stat-item-satisfaction",
];

export default function AboutStats({ about }) {
  const stats = about.stats || [];
  return (
    <>
      <section id="despre" className="py-20 sm:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            {about.image_url ? (
              <div className="rounded-2xl overflow-hidden border border-[#E2E8F0] shadow-xl">
                <img
                  src={resolveImg(about.image_url)}
                  alt="Atelier SIMSERV"
                  className="w-full h-[380px] object-cover"
                />
              </div>
            ) : null}
            <div className="absolute -bottom-6 -right-4 sm:right-6 bg-[#FF5A1F] text-white rounded-2xl px-6 py-4 shadow-xl hidden sm:block">
              <p className="font-display text-3xl font-extrabold leading-none">
                {stats[0]?.value || "15+"}
              </p>
              <p className="text-xs font-semibold uppercase tracking-wide mt-1 text-white/90">
                Ani de experiență
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-3">
              // Despre Noi
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F1E36] leading-tight">
              {about.heading}
            </h2>
            <p className="mt-5 text-base text-slate-600 leading-relaxed">
              {about.text}
            </p>
            <ul className="mt-7 space-y-3">
              {[
                "Diagnoză computerizată multimarcă",
                "Decontare directă cu asigurătorii",
                "Piese cu garanție și manoperă certificată",
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-[#0F1E36] font-medium">
                  <CheckCircle2 className="w-5 h-5 text-[#16A34A] shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </section>

      <section id="cifre" className="pb-20 sm:pb-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl bg-[#0F1E36] p-8 sm:p-12">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((st, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  data-testid={STAT_IDS[i] || `stat-item-${i}`}
                  className="text-center sm:text-left"
                >
                  <p className="font-display text-4xl sm:text-5xl font-extrabold text-[#FF5A1F]">
                    {st.value}
                  </p>
                  <p className="mt-2 font-semibold text-white">{st.label}</p>
                  <p className="mt-1 text-sm text-white/50 leading-snug">
                    {st.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
